// Packages
import styled from "styled-components";

export const SectionTextBlockContent = styled.div(({ theme, $border }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",

  paddingLeft: $border ? "20px" : "none",
  borderLeft: $border ? `1px solid #40BCFF` : "none",

  [theme.breakpoint.lg()]: {
    paddingLeft: $border ? "32px" : "none",
  },
}));

export const SectionTextBlockHeader = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
}));

export const SectionTextBlockTitle = styled.h2(({ theme }) => ({
  color: theme.color.brandPrimary.light,
  fontSize: "28px",
  fontWeight: 700,
  lineHeight: 1,
  padding: 0,
  margin: 0,

  [theme.breakpoint.lg()]: {
    fontSize: "40px",
  },
}));

export const SectionBlockSubTitle = styled.div(({ theme }) => ({
  color: theme.color.neutral["02"],
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "150%",
}));

export const SectionTextBlockDescription = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  color: theme.color.neutral["02"],
  fontSize: "18px",
  fontWeight: 500,
  lineHeight: "160%",

  p: {
    marginTop: "0",
  },

  [theme.breakpoint.lg()]: {
    fontSize: "20px",
  },
}));

export const SectionTextBlockLink = styled.a(({ theme }) => ({
  color: theme.color.brandPrimary.light,
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "150%",
  textDecoration: "underline",

  [theme.breakpoint.lg()]: {
    fontSize: "18px",
  },
}));

export const SectionTextBlockContentLink = styled.div(() => ({
  display: "flex",
  gap: "8px",
}));
